import { useRef, useEffect } from 'react';
import { useInView } from 'framer-motion';

// Détecte quand ce bloc de texte croise la zone de déclenchement du viewport pendant le scroll,
// et le signale au parent pour piloter le visuel épinglé à côté (effet "image fixe, texte défile").
// `margin` permet de décaler cette zone quand une image épinglée occupe une grosse partie de
// l'écran en mobile (sinon le déclenchement, calé sur le centre de l'écran, arrive trop tard).
const TextStep = ({
  index, onActive, isActive, className = '', style, margin = '-45% 0px -45% 0px',
  heightClass = 'min-h-[70vh] md:min-h-[calc(100dvh-var(--fh))]',
  padClass = 'pt-16 md:pt-0', children,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { margin });

  useEffect(() => {
    if (inView) onActive(index);
  }, [inView, index, onActive]);

  return (
    <div
      ref={ref}
      style={style}
      className={`${heightClass} flex flex-col justify-start md:justify-center ${padClass} transition-opacity duration-500 ${isActive ? 'opacity-100' : 'opacity-40'} ${className}`}
    >
      {children}
    </div>
  );
};

export default TextStep;
